import { takeEvery, put } from 'redux-saga/effects';

import { IFlowOptions, ITokenData } from 'types';
import { fetchBearerToken, makeGetRequest, makePostRequest } from 'tools/utilities/ajax';
import {
  TYPES, IGetOptionsSuccess, IGetOptionsFailure, IStoreToken,
} from './actions';
import { normaliseConfigFromCRM } from './normaliseConfigFromCRM';
import {
  CRMSimpleItem, CRMBank, CRMOptionSet, CRMProductsWithDetails, CRMCity,
} from './crmTypes';

// @NOTE This is called in RenewToken component
function* getBearerToken() {
  // Get bearer token from Microsoft Azure
  const tokenData: ITokenData = yield fetchBearerToken();

  // While the website is running, fetch a new bearerToken
  yield put<IStoreToken>({
    type: TYPES.STORE_TOKEN,
    payload: {
      tokenData,
    },
  });
}

function* getOptions() {
  try {
    // Get bearer token from Microsoft Azure
    const tokenData: ITokenData = yield fetchBearerToken();
    const { accessToken } = tokenData;

    yield put<IStoreToken>({
      type: TYPES.STORE_TOKEN,
      payload: {
        tokenData,
      },
    });

    const requests = yield Promise.all([
      // Bank options
      makeGetRequest<CRMBank[]>('/api/Bank/GetBanks', {}, accessToken),

      // ProductsWithDetails - Contains Plans - Calculator Only, Full Service, Level 2 and Extras - SmartHR
      makeGetRequest<CRMProductsWithDetails[]>('/api/Products/GetProductsWithDetails', {
        productId: '',
      }, accessToken),

      // leadSource
      makeGetRequest<CRMSimpleItem[]>('/api/Lead/GetLeadSources', {}, accessToken),

      // industryTypes
      makeGetRequest<CRMSimpleItem[]>('/api/Industry/GetIndustries', {}, accessToken),

      makePostRequest<Record<string, CRMOptionSet>>('/api/OptionSet/GetOptionSetArray', {
        name: [
          'dsl_hrmanagementmethod',
          'dsl_payrollprocessingpreference',
          'dsl_jobtitle',
          'dsl_accesslevel',
          'dsl_paycycle',
          'dsl_payrollprocessingmethod',
          'dsl_payeirdpaymentfrequency',
          'dsl_annualleaverollover',
        ],
      }, accessToken),

      // @NOTE these have been hardcoded in callback-request/sagas as there's not much point in retrieving them each time
      // as they should never change.
      makeGetRequest<CRMSimpleItem[]>('/api/Lead/GetLeadChannels', {}, accessToken),

      makeGetRequest<CRMCity[]>('/api/Addresses/GetCities', {}, accessToken),
      makeGetRequest<CRMCity[]>('/api/Addresses/GetRegions', {}, accessToken),

      // makeGetRequest<any>('api/Products/GetPlans', { productId: '' }, accessToken),
      makeGetRequest<CRMSimpleItem[]>('/api/Products/GetCompetingProducts', {}, accessToken),
    ]);

    const [
      bankOptions,
      productsWithDetails,
      leadSource,
      industryTypes,
      [
        manageHrOptions,
        managePayCycleOptions,
        jobTitles,
        accountantHasAccessTo,
        payCycles,
        payrollProcessingModes,
        irdPaymentFrequencies,
        employeeLeaveRollover,
      ],
      leadChannels,
      cities,
      regions,
      competingProducts,
    ] = requests;

    // console.log('🤔🤔🤔 requests', requests);

    const options: IFlowOptions = normaliseConfigFromCRM({
      bankOptions,
      productsWithDetails,
      leadSource,
      industryTypes,
      manageHrOptions,
      managePayCycleOptions,
      jobTitles,
      accountantHasAccessTo,
      payrollProcessingModes,
      irdPaymentFrequencies,
      employeeLeaveRollover,
      payCycles,
      cities,
      regions,
      competingProducts,
      leadChannels,
    });

    console.log('🤔🤔🤔 options', options);

    yield put<IGetOptionsSuccess>({
      type: TYPES.GET_OPTIONS_SUCCESS,
      payload: {
        options,
      },
    });
  } catch (error) {
    console.error(error);
    yield put<IGetOptionsFailure>({
      type: TYPES.GET_OPTIONS_FAILURE,
      payload: {
        error: 'Something went wrong.',
      },
    });
  }
}

export function* optionsSaga() {
  yield takeEvery(TYPES.GET_OPTIONS, getOptions);
  yield takeEvery(TYPES.GET_TOKEN, getBearerToken);
}
